import { Pie, getElementAtEvent } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useRef } from "react";

type DataItem<T> = {
  label: string;
  value: T;
  total?: T;
}

type Props<T> = {
  data: DataItem<T>[];
  title: string;
  onDataClick?: (item: DataItem<T>) => void
}


export default function PieChart<T>({ data, title, onDataClick }: Props<T>) {
  const ref = useRef<any>();

  const handleClick = (ev: any) => {
    if (onDataClick) {
      const [el] = getElementAtEvent(ref.current, ev);
      onDataClick(data[el.index]);
    }
  }

  const chartData = {
    labels: data.map(({ label }) => label),
    datasets: [
      {
        label: title,
        data: data.map(({ value }) => value as T),
        backgroundColor: [
          "#00EFEF",
          "#0089A9",
          "#06B2DA",
          "#51E0C4",
          "#25BB9D",
        ]
      },
    ]
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom" as const,
        display: true,
        labels: {
          boxWidth: 6,
          boxHeight: 6,
          usePointStyle: true,
          padding: 20
        }
      },
      title: {
        display: false,
        text: "",
      },
      datalabels: {
        font: {
          weight: 500,
          color: "#fff",
        },
        backgroundColor: "white",
        padding: {
          top: 1,
          bottom: 1,
          left: 3,
          right: 3
        },
        display: 'auto',
        formatter: (v: number) => `${v.toFixed(2)}%`,
      },
      tooltip: {
        callbacks: {
          label(context: any) {
            const total = data[context.dataIndex].total;
            return ` ${context.parsed.toFixed(2)}% of total${total ? ` (${total})` : ''}`;
          }
        }
      }
    },
  };

  /* @ts-ignore */
  return <Pie ref={ref} data={chartData} plugins={[ChartDataLabels]} options={options} onClick={handleClick} />;
}